const siteName = 'Bukalapak';
const image = 'https://s4.bukalapak.com/images/bukareksa/bukareksa_social_banner.jpg';
const app = 'android-app://com.bukalapak.android/https/www.bukalapak.com//bukareksa';

module.exports = {
  default: {
    title: 'Investasi Reksadana Online Terbaik hanya di BukaReksa',
    description:
      'BukaReksa memberikan kemudahan dalam berinvestasi reksadana dengan bantuan para profesional. Buka rekening reksadana secara online bisa cepat dan mudah.',
    desktop: 'https://www.bukalapak.com/bukareksa',
    mobile: 'https://m.bukalapak.com/bukareksa',
    image,
    site_name: siteName,
    app,
  },
};
